import React from 'react';
import PropTypes from 'prop-types';

import Icon from '../../../../components/Icon';

import { S } from './styles';
import './styles.css';

function Pagination({
  currentPage,
  pageLimit,
  totalItems,
  onChangePage,
  ...props
}) {
  const _getMaxPages = () =>
    totalItems === 0 ? 1 : Math.ceil(totalItems / pageLimit);

  const renderNavControl = pageNumber => (
    <span
      key={pageNumber}
      className={`Pagination__nav-control${
        currentPage === pageNumber ? ' Pagination__nav-control--selected' : ''
      }`}
      onClick={() => onChangePage(pageNumber)}
    >
      {pageNumber}
    </span>
  );

  const renderMoreIcon = key => (
    <Icon key={key} className="Pagination__more-icon" name="more_horiz" />
  );

  const _renderPageControl = () => {
    const pageControl = [];

    if (maxPage < 6) {
      for (let i = 1; i <= maxPage; i++) {
        pageControl.push(renderNavControl(i));
      }
    } else {
      pageControl.push(renderNavControl(1));

      if (currentPage <= 3) {
        pageControl.push(renderNavControl(2));
        pageControl.push(renderNavControl(3));
        pageControl.push(renderNavControl(4));
        pageControl.push(renderMoreIcon('icon-more'));
      } else if (currentPage > 3 && currentPage <= maxPage - 3) {
        pageControl.push(renderMoreIcon('icon-more-1'));
        pageControl.push(renderNavControl(currentPage - 1));
        pageControl.push(renderNavControl(currentPage));
        pageControl.push(renderNavControl(currentPage + 1));
        pageControl.push(renderMoreIcon('icon-more-2'));
      } else {
        pageControl.push(renderMoreIcon('icon-more'));
        pageControl.push(renderNavControl(maxPage - 3));
        pageControl.push(renderNavControl(maxPage - 2));
        pageControl.push(renderNavControl(maxPage - 1));
      }

      pageControl.push(renderNavControl(maxPage));
    }

    return pageControl;
  };

  const _previousPage = () => {
    const previousPage = currentPage - 1;
    previousPage > 0 && onChangePage(previousPage);
  };

  const _nextPage = () => {
    const nextPage = currentPage + 1;
    nextPage <= maxPage && onChangePage(nextPage);
  };

  const maxPage = _getMaxPages();

  return (
    <S.FooterContainer>
      <div className="TrackingPaginationWrapper" {...props}>
        <div className="TrackingPagination__nav">
          <span
            className={`TrackingPagination__nav-control${
              currentPage === 1
                ? ' TrackingPagination__nav-control--disabled'
                : ''
            }`}
            onClick={_previousPage}
          >
            <Icon
              className="TrackingPagination__nav-control-icon"
              name="keyboard_arrow_left"
            />
          </span>
          {_renderPageControl()}
          <span
            className={`TrackingPagination__nav-control${
              currentPage === maxPage
                ? ' TrackingPagination__nav-control--disabled'
                : ''
            }`}
            onClick={_nextPage}
          >
            <Icon
              className="TrackingPagination__nav-control-icon"
              name="keyboard_arrow_right"
            />
          </span>
        </div>
      </div>
    </S.FooterContainer>
  );
}

Pagination.propTypes = {
  paginationConfig: PropTypes.object,
  currentPage: PropTypes.number,
  totalItems: PropTypes.number,
  onPageLimitChange: PropTypes.func,
  onChangePage: PropTypes.func,
};

export default Pagination;
